export default __webpack_public_path__ + "img/motion-sensor.af9abdab.png";